import EnumService from '../EnumService'

export default class EstadoEnumService extends EnumService{

    constructor(){
        super('enumEstado');
    }
  
  }
  